<template>
  <div style="margin-top:60px;">
    <el-container>
      <el-aside width="200px">
        <el-menu class="el-menu-vertical"
                 router
                 :default-active="$route.path">

          <el-menu-item index="/personalCenter/personalCenter">
            <i class="el-icon-user"></i>
            <span slot="title">会员中心</span>
          </el-menu-item>
          <el-menu-item index="/personalCenter/myaddon">
            <i class="el-icon-box"></i>
            <span slot="title">我购买的插件</span>
          </el-menu-item>
          <!-- <el-menu-item index="/personalCenter/recharge">
            <i class="el-icon-bank-card"></i>
            <span slot="title">充值余额</span>
          </el-menu-item> -->

          <el-submenu index="developerCenter">
            <template slot="title">
              <i class="el-icon-s-cooperation"></i>
              <span>开发者中心</span>
            </template>
            <el-menu-item index="/personalCenter/developerApply">
              <i class="el-icon-s-check"></i>
              <span slot="title">开发者认证</span>
            </el-menu-item>
            <el-menu-item index="/personalCenter/developerMyPlugins">
              <i class="el-icon-s-grid"></i>
              <span slot="title">我的插件</span>
            </el-menu-item>
            <el-menu-item index="/personalCenter/developerPluginOrders">
              <i class="el-icon-s-order"></i>
              <span slot="title">插件订单</span>
            </el-menu-item>
            <el-menu-item index="/personalCenter/developerIncome">
              <i class="el-icon-s-finance"></i>
              <span slot="title">我的收益</span>
            </el-menu-item>
            <el-menu-item index="/personalCenter/developerBankAccount">
              <i class="el-icon-bank-card"></i>
              <span slot="title">收款账户</span>
            </el-menu-item>
            <el-menu-item index="/personalCenter/developerWithdraw">
              <i class="el-icon-sold-out"></i>
              <span slot="title">提现</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item index="/personalCenter/profile">
            <i class="el-icon-setting"></i>
            <span slot="title">账户设置</span>
          </el-menu-item>
        </el-menu>

      </el-aside>
      <el-main>
        <app-main />
      </el-main>
    </el-container>

  </div>

</template>

<script>
import AppMain from './components/AppMain.vue'
export default {
  name: 'layoutPersonalCenter',
  components: {
    AppMain
  }
}
</script>

<style scoped>
.el-menu-vertical {
  height: 100%;
}
</style>
